class Impersonate {
  constructor(options = {}) {
    this.config = {
      module: document.querySelector('[data-module="ImpersonateBar"]'),
      ...options
    };
  }

  init() {
    const { module } = this.config;

    if (!module) {
      return;
    }

    const impersonateTimer = module.querySelector('[data-child-module="ImpersonateTimer"]');
    if (impersonateTimer) {
      let { secondsLeft } = impersonateTimer.dataset;

      window.setInterval(() => {
        secondsLeft -= 1;
        const timer = new Date(secondsLeft * 1000).toISOString().substr(11, 8);

        if (secondsLeft < 0) {
          window.location.href = '/StopImpersonate';
        } else {
          impersonateTimer.innerHTML = timer;
        }
      }, 1000);
    }
  }
}

export default Impersonate;
